import React from "react";
import * as RadixTabs from "@radix-ui/react-tabs";
import { TabsRootProps } from "../types";

export const Root = ({ onValueChange, ...props }: TabsRootProps) => {
  const handleValueChange = (value: string) => {
    onValueChange?.(value);
  };

  return <RadixTabs.Root {...props} onValueChange={handleValueChange} />;
};
